export const GET_COMPANY_DATA = 'app/containers/CompanyIndex/GET_COMPANY_DATA'
export const GET_COMPANY_DATA_SUCCESS =
  'app/containers/CompanyIndex/GET_COMPANY_DATA_SUCCESS'
export const GET_COMPANY_DATA_FAILED =
  'app/containers/CompanyIndex/GET_COMPANY_DATA_FAILED'

export const SELECT_COMPANY = 'app/containers/CompanyIndex/SELECT_COMPANY'
